import React, { useCallback, useContext, useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import {
  CircularProgress,
  Tooltip,
  Select,
  MenuItem,
  FormControl,
  InputAdornment,
  TextField,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  Paper,
  TablePagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
  FormHelperText,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { ContextSession } from "../../../services/ContextSession";
import { appColors } from "../../../services/theme.service";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import IconButton from "@mui/material/IconButton";
import Popover from "@mui/material/Popover";
import CryptoJS from "crypto-js";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HandymanIcon from "@mui/icons-material/Handyman";
import DeleteIcon from "@mui/icons-material/Delete";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: appColors.brand.primary,
    color: appColors.neutral.white,
    fontSize: 16,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    borderRight: "none", // Elimina la línea vertical entre columnas
    borderLeft: "none", // Elimina la línea vertical entre columnas
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "&:hover": {
    // Agrega estilo al pasar el cursor sobre la fila
    backgroundColor: "#C1C1C1", // Cambia el color de fondo al pasar el cursor
  },
}));

function ListaSolConstanciasRevisionCC() {
  let sessi = useContext(ContextSession);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [statusFilter, setStatusFilter] = useState("6");
  const [searchDNI, setSearchDNI] = useState("");
  const handleSearchDNIChange = (event) => setSearchDNI(event.target.value);
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const estadosConstancia = {
    1: "PENDIENTE DE PAGO",
    2: "PAGADA",
    3: "CANCELADA",
    4: "EMITIDA",
    5: "ANULADA",
    6: "REVISANDO",
  };

  const tiposConstancia = {
    1: "HISTORIAL DE COTIZACIONES",
    2: "RAZONADA",
    3: "SALDOS PROYECTADOS",
    4: "NO TENER PRÉSTAMO ACTIVO",
    5: "TRÁMITE EMBAJADA",
    6: "PAGO DE PRESTACIONES",
    8: "PAGO DE PRESTACIONES",
  };

  const estadoFiltroLabels = {
    6: "Pendiente de Aprobar",
    1: "Pendiente de Pago",
    Entrega: "Pendiente de Entregar",
    4: "Emitida",
  };

  const renderEstadoFiltro = (value) => {
    if (String(value) === "2") {
      return (
        <Box sx={{ lineHeight: 1.2 }}>
          <Box component="span" sx={{ display: "block" }}>
            Pagadas
          </Box>
          <Box
            component="span"
            sx={{
              color: "success.main",
              display: "block",
              fontSize: 12,
              fontWeight: 700,
            }}
          >
            Pendiente de Emitir
          </Box>
        </Box>
      );
    }

    return estadoFiltroLabels[value] || "";
  };

  const isPendienteEntregar = (row) =>
    row.fk_id_estado === 2 &&
    row.enviadaOficina === true &&
    row.recepcionOficina === true &&
    row.oficinaEntregaParticipante === false;

  const isPagadaPendienteEmitir = (row) =>
    row.fk_id_estado === 2 && row.enviadaOficina !== true;

  const getEstadoConstanciaText = (row) => {
    if (isPendienteEntregar(row)) {
      return "PENDIENTE DE ENTREGAR";
    }

    return estadosConstancia[row.fk_id_estado] || "DESCONOCIDO";
  };

  // const dominio = "http://172.20.7.10:8082";
  //const dominio = "https://be.injupemp.gob.hn:8443";
  //const dominio = "http://127.0.0.1:8000"; -- Error identificado previo al 23 junio 2026 - jsauceda
  const dominio = "https://be.injupemp.gob.hn:8443"; //cambio realizado 23 junio 2026 - jsauceda

  // NUEVO: estados para dialog y fila seleccionada
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [patchLoading, setPatchLoading] = useState(false);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [openDialogSubsanar, setOpenDialogSubsanar] = useState(false);
  const [openSuccessDialogSubsanar, setOpenSuccessDialogSubsanar] =
    useState(false);
  const [observacion, setObservacion] = useState("");
  const [camposSeleccionados, setCamposSeleccionados] = useState({
    copiaDNI: false,
    copiaAcuCancelacion: false,
    copiaSolPension: false,
  });
  const [errorObservacion, setErrorObservacion] = useState(false);
  const [errorDocumentos, setErrorDocumentos] = useState(false);

  const [openDialogRechazar, setOpenDialogRechazar] = useState(false);
  const [openSuccessDialogRechazar, setOpenSuccessDialogRechazar] =
    useState(false);
  const [openDialogRecibido, setOpenDialogRecibido] = useState(false);
  const [openSuccessDialogRecibido, setOpenSuccessDialogRecibido] =
    useState(false);
  const [errorRecepcion, setErrorRecepcion] = useState("");
  const [archivoConstanciaDigital, setArchivoConstanciaDigital] =
    useState(null);
  const [openDialogEntrega, setOpenDialogEntrega] = useState(false);
  const [openSuccessDialogEntrega, setOpenSuccessDialogEntrega] =
    useState(false);
  const [errorEntrega, setErrorEntrega] = useState("");
  const [archivoComprobante, setArchivoComprobante] = useState(null);

  useEffect(() => {
    const documentosValidos =
      camposSeleccionados.copiaDNI ||
      camposSeleccionados.copiaAcuCancelacion ||
      camposSeleccionados.copiaSolPension;
    const observacionValida = observacion.trim().length > 0;

    setErrorDocumentos(!documentosValidos);
    setErrorObservacion(!observacionValida);
  }, [camposSeleccionados, observacion]);

  // 1. Mueve fetchData fuera de useEffect
  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const secretKey =
        "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8";
      const estadoConsulta = statusFilter === "Entrega" ? "2" : statusFilter;
      const queryString = `IdEstado=${estadoConsulta}`;
      const signature = CryptoJS.HmacSHA256(queryString, secretKey).toString(
        CryptoJS.enc.Hex
      );

      //const response = await fetch(`https://be.injupemp.gob.hn:8443/api/ConstanciaPag/ConstanciaSG/?IdEstado=${statusFilter}`, {
      const response = await fetch(
        // `http://172.20.7.10:8082/api/ConstanciaPag/ConstanciaSG/?IdEstado=${statusFilter}`,
        `${dominio}/api/ConstanciaPag/ConstanciaRevisionCC/?IdEstado=${estadoConsulta}`,
        {
          method: "GET",
          headers: {
            "X-Signature": signature,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) throw new Error("Error al obtener los datos");
      const data = await response.json();
      setRows(data);
    } catch (error) {
      setRows([]);
    }
    setLoading(false);
  }, [statusFilter]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [filterType, setFilterType] = useState("");

  const handleFilterClick = (event, type) => {
    setAnchorEl(event.currentTarget);
    setFilterType(type);
  };

  const handleFilterClose = () => {
    setAnchorEl(null);
    setFilterType("");
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const filteredRows = rows.filter((row) => {
    const meetsInitialCriteria =
      statusFilter === "Entrega"
        ? isPendienteEntregar(row)
        : statusFilter === "2"
        ? isPagadaPendienteEmitir(row)
        : statusFilter === "6"
        ? row.fk_id_estado === 6 && row.secretariaGeneralAprobado === null
        : row.fk_id_estado === Number(statusFilter);

    // Si hay búsqueda por DNI, aplica el filtro adicional
    if (searchDNI.trim() !== "") {
      // Asegúrate de que row.dniSolicitante existe y coincide con la búsqueda
      const dniMatch =
        row.DNI_usuario &&
        row.DNI_usuario.toString()
          .toLowerCase()
          .includes(searchDNI.toLowerCase());

      return meetsInitialCriteria && dniMatch;
    }

    return meetsInitialCriteria;
  });

  // --- Función para abrir el dialog ---
  const handleOpenDialog = (row) => {
    setSelectedRow(row);
    setOpenDialog(true);
  };

  // 2. PATCH y dialog de éxito
  const handleAccept = async () => {
    if (!selectedRow) return;
    setPatchLoading(true);
    try {
      const secretKey =
        "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8";
      const idSolicitud = selectedRow.id_solicitud_constancia;
      const idUser = sessi.sessionData.id;
      const queryString = `IdSolicitud=${idSolicitud}`;
      const signature = CryptoJS.HmacSHA256(queryString, secretKey).toString(
        CryptoJS.enc.Hex
      );
      //const url = `http://172.20.7.10:8082/api/ConstanciaPag/ConstanciaSG/Aprobar/?IdSolicitud=${idSolicitud}&IdUserSG=${idUser}`;
      const url = `${dominio}/api/ConstanciaPag/ConstanciaSG/Aprobar/?IdSolicitud=${idSolicitud}&IdUserSG=${idUser}`;

      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "X-Signature": signature,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) throw new Error("Error al aprobar la solicitud");
      // CIERRA el dialog y muestra el de éxito
      setOpenDialog(false);
      setOpenSuccessDialog(true);
    } catch (error) {
      alert("Ocurrió un error al aprobar la solicitud.");
    }
    setPatchLoading(false);
  };

  // 3. Cuando el usuario acepta el dialog de éxito, cierra el dialog y actualiza la tabla
  const handleSuccessDialogClose = () => {
    setOpenSuccessDialog(false);
    fetchData();
  };

  ////////////////////////////////////////////////////////////////////////////////////// SUBSANAR

  const handleOpenDialogSubsanar = (row) => {
    setSelectedRow(row);
    setOpenDialogSubsanar(true);
  };

  // 2. PATCH y dialog de SUBSANAR
  const handleAcceptSubsanar = async () => {
    if (!selectedRow) return;
    setPatchLoading(true);
    try {
      const campos = [];
      if (camposSeleccionados.copiaDNI) campos.push("CopiaDNI");
      if (camposSeleccionados.copiaAcuCancelacion)
        campos.push("copiaAcuCancelacion");
      if (camposSeleccionados.copiaSolPension) campos.push("copiaSolPension");
      const camposString = campos.join(",");

      const secretKey =
        "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8";
      const idSolicitud = selectedRow.id_solicitud_constancia;
      // const idUser = sessi.sessionData.id;

      /*const requestBody = {
            Observacion: observacion, // Usa el estado en lugar de un texto fijo
            campos: camposString, // Ajusta según lo que necesites
            IdSolicitud: idSolicitud,
            //IdUserSG: idUser,
            };*/

      const formData = new FormData();
      formData.append("Observacion", observacion);
      formData.append("Campos", camposString);
      formData.append("IdSolicitud", idSolicitud);

      const queryString = `IdSolicitud=${idSolicitud}`;
      const signature = CryptoJS.HmacSHA256(queryString, secretKey).toString(
        CryptoJS.enc.Hex
      );
      //const url = `http://172.20.7.10:8082/api/ConstanciaPag/Habilitar/Subsanacion/`;
      const url = `${dominio}/api/ConstanciaPag/Habilitar/Subsanacion/`;

      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "X-Signature": signature,
        },
        body: formData,
      });

      if (!response.ok) throw new Error("Error al aprobar la solicitud");
      // CIERRA el dialog y muestra el de éxito
      setOpenDialogSubsanar(false);
      setOpenSuccessDialogSubsanar(true);
    } catch (error) {
      alert("Ocurrió un error al aprobar la solicitud.");
    }
    setPatchLoading(false);
  };

  // 3. Cuando el usuario acepta el dialog de éxito, cierra el dialog y actualiza la tabla
  const handleSuccessDialogSubsanarClose = () => {
    setOpenSuccessDialogSubsanar(false);
    fetchData();
    setObservacion("");
    setCamposSeleccionados({
      copiaDNI: false,
      copiaAcuCancelacion: false,
      copiaSolPension: false,
    });
  };

  // 3. Cuando el usuario acepta el dialog de éxito, cierra el dialog y actualiza la tabla
  const handleCloseDialogSubsanar = () => {
    setOpenDialogSubsanar(false);
    fetchData();
    setObservacion("");
    setCamposSeleccionados({
      copiaDNI: false,
      copiaAcuCancelacion: false,
      copiaSolPension: false,
    });

    setErrorObservacion(false);
    setErrorDocumentos(false);
  };

  //////////////////////////////////////////////////////////////////////////////////////

  ////////////////////////////////////////////////////////////////////////////////////// RECHAZAR

  const handleOpenDialogRechazar = (row) => {
    setSelectedRow(row);
    setOpenDialogRechazar(true);
  };

  // 2. PATCH y dialog de RECHAZAR
  const handleAcceptRechazar = async () => {
    if (!selectedRow) return;
    setPatchLoading(true);
    try {
      const secretKey =
        "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8";
      const idSolicitud = selectedRow.id_solicitud_constancia;
      // const idUser = sessi.sessionData.id;

      /*const requestBody = {
            Observacion: observacion, // Usa el estado en lugar de un texto fijo
            campos: camposString, // Ajusta según lo que necesites
            IdSolicitud: idSolicitud,
            //IdUserSG: idUser,
            };*/

      const formData = new FormData();
      formData.append("Observacion", observacion);
      formData.append("IdSolicitud", idSolicitud);

      const queryString = `IdSolicitud=${idSolicitud}`;
      const signature = CryptoJS.HmacSHA256(queryString, secretKey).toString(
        CryptoJS.enc.Hex
      );
      //const url = `http://172.20.7.10:8082/api/ConstanciaPag/Cancelar/Solicitud/`;
      const url = `${dominio}/api/ConstanciaPag/Cancelar/Solicitud/`;

      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "X-Signature": signature,
        },
        body: formData,
      });

      if (!response.ok) throw new Error("Error al cancelar la solicitud");
      // CIERRA el dialog y muestra el de éxito
      setOpenDialogRechazar(false);
      setOpenSuccessDialogRechazar(true);
    } catch (error) {
      alert("Ocurrió un error al cancelar la solicitud.");
    }
    setPatchLoading(false);
  };

  // 3. Cuando el usuario acepta el dialog de éxito, cierra el dialog y actualiza la tabla
  const handleSuccessDialogRechazarClose = () => {
    setOpenSuccessDialogRechazar(false);
    fetchData();
    setObservacion("");
  };

  // 3. Cuando el usuario acepta el dialog de éxito, cierra el dialog y actualiza la tabla
  const handleCloseDialogRechazar = () => {
    setOpenDialogRechazar(false);
    fetchData();
    setObservacion("");
  };

  //////////////////////////////////////////////////////////////////////////////////////

  ////////////////////////////////////////////////////////////////////////////////////// RECEPCION

  const handleOpenDialogRecibido = (row) => {
    setSelectedRow(row);
    setErrorRecepcion("");
    setArchivoConstanciaDigital(null);
    setOpenDialogRecibido(true);
  };

  const handleAcceptRecibido = async () => {
    if (!selectedRow || !archivoConstanciaDigital) return;
    setPatchLoading(true);
    setErrorRecepcion("");

    try {
      const secretKey =
        "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8";
      const idSolicitud = selectedRow.id_solicitud_constancia;
      const username = sessi.sessionData.username;
      const formData = new FormData();
      formData.append("IdSolicitud", idSolicitud);
      formData.append("Usuario", username);
      formData.append(
        "ConstanciaEscaneadaDigital",
        archivoConstanciaDigital
      );

      const queryString = `IdSolicitud=${idSolicitud}`;
      const signature = CryptoJS.HmacSHA256(queryString, secretKey).toString(
        CryptoJS.enc.Hex
      );
      const url = `${dominio}/api/ConstanciaPag/MarcarRecibida/Oficina/`;

      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "X-Signature": signature,
        },
        body: formData,
      });

      if (!response.ok) {
        let message = "Error al confirmar la recepcion de la constancia.";
        try {
          const data = await response.json();
          message = data?.error || data?.message || message;
        } catch {
          // Mantiene el mensaje por defecto si la respuesta no es JSON.
        }
        throw new Error(message);
      }

      setOpenDialogRecibido(false);
      setOpenSuccessDialogRecibido(true);
      setArchivoConstanciaDigital(null);
    } catch (error) {
      setErrorRecepcion(
        error.message || "Ocurrio un error al confirmar la recepcion."
      );
    } finally {
      setPatchLoading(false);
    }
  };

  const handleSuccessDialogRecibidoClose = () => {
    setOpenSuccessDialogRecibido(false);
    setSelectedRow(null);
    setArchivoConstanciaDigital(null);
    fetchData();
  };

  const handleCloseDialogRecibido = () => {
    setOpenDialogRecibido(false);
    setErrorRecepcion("");
    setArchivoConstanciaDigital(null);
  };

  //////////////////////////////////////////////////////////////////////////////////////

  ////////////////////////////////////////////////////////////////////////////////////// ENTREGA

  const handleOpenDialogEntrega = (row) => {
    setSelectedRow(row);
    setErrorEntrega("");
    setArchivoComprobante(null);
    setOpenDialogEntrega(true);
  };

  const handleAcceptEntrega = async () => {
    if (!selectedRow || !archivoComprobante) return;
    setPatchLoading(true);
    setErrorEntrega("");

    try {
      const secretKey =
        "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8";
      const idSolicitud = selectedRow.id_solicitud_constancia;
      const username = sessi.sessionData.username;
      const formData = new FormData();
      formData.append("IdSolicitud", idSolicitud);
      formData.append("Usuario", username);
      formData.append("CopiaComprobanteEntrega", archivoComprobante);

      const queryString = `IdSolicitud=${idSolicitud}`;
      const signature = CryptoJS.HmacSHA256(queryString, secretKey).toString(
        CryptoJS.enc.Hex
      );
      const url = `${dominio}/api/ConstanciaPag/MarcarEntregada/Oficina/`;

      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "X-Signature": signature,
        },
        body: formData,
      });

      if (!response.ok) {
        let message = "Error al confirmar la entrega de la constancia.";
        try {
          const data = await response.json();
          message = data?.error || data?.message || message;
        } catch {
          // Mantiene el mensaje por defecto si la respuesta no es JSON.
        }
        throw new Error(message);
      }

      setOpenDialogEntrega(false);
      setOpenSuccessDialogEntrega(true);
      setArchivoComprobante(null);
    } catch (error) {
      setErrorEntrega(
        error.message || "Ocurrio un error al confirmar la entrega."
      );
    } finally {
      setPatchLoading(false);
    }
  };

  const handleSuccessDialogEntregaClose = () => {
    setOpenSuccessDialogEntrega(false);
    setSelectedRow(null);
    setArchivoComprobante(null);
    fetchData();
  };

  const handleCloseDialogEntrega = () => {
    setOpenDialogEntrega(false);
    setErrorEntrega("");
    setArchivoComprobante(null);
  };

  //////////////////////////////////////////////////////////////////////////////////////

  const handleClick = (id) => {
    sessi.setVariable("IDsolConstanciaSG", id);
    navigate("/PortalDelParticipante/VerSolicitudConstanciaCC");
  };

  return (
    <div className="container" style={{ marginTop: 10 }}>
      <>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 10,
          }}
        >
          <h2>
            <b>Lista de Solicitudes de Constancias en INJUPEMP Conectados</b>
          </h2>
        </div>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            flexWrap: "wrap",
            mb: 2,
            mt: 1,
            justifyContent: "center", // <--- Cambia aquí
          }}
        >
          <FormControl size="small" sx={{ minWidth: 230 }}>
            <FormHelperText>Filtrar Constancias:</FormHelperText>
            <Select
              value={statusFilter}
              onChange={(e) => {
                setStatusFilter(e.target.value);
                setPage(0);
              }}
              displayEmpty
              fullWidth
              renderValue={renderEstadoFiltro}
              sx={{
                "& .MuiSelect-select": {
                  alignItems: "center",
                  display: "flex",
                  minHeight: 36,
                  py: 0.75,
                },
              }}
            >
              <MenuItem value="6">Pendiente de Aprobar</MenuItem>
              <MenuItem value="1">Pendiente de Pago</MenuItem>
              <MenuItem value="2">
                <Box sx={{ lineHeight: 1.2 }}>
                  <Box component="span" sx={{ display: "block" }}>
                    Pagadas
                  </Box>
                  <Box
                    component="span"
                    sx={{
                      color: "success.main",
                      display: "block",
                      fontSize: 12,
                      fontWeight: 700,
                    }}
                  >
                    Pendiente de Emitir
                  </Box>
                </Box>
              </MenuItem>
              <MenuItem value="Entrega">Pendiente de Entregar</MenuItem>
              <MenuItem value="4">Emitida</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <div className="row" style={{ marginTop: "20px" }}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell>#</StyledTableCell>
                  <StyledTableCell>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <strong>DNI Solicitante</strong>
                      <Tooltip title="Buscar por DNI" arrow>
                        <IconButton
                          onClick={(event) =>
                            handleFilterClick(event, "searchDNI")
                          }
                          color={searchDNI ? "primary" : "default"}
                        >
                          <ManageSearchIcon
                            style={{
                              color: searchDNI ? "#1976d2" : "white",
                            }}
                          />
                        </IconButton>
                      </Tooltip>
                      {/* {searchDNI && (
                        <Chip
                          label={`DNI: ${searchDNI}`}
                          size="small"
                          onDelete={() => setSearchDNI("")}
                          sx={{ ml: 1, height: 24 }}
                        />
                      )} */}
                    </div>
                  </StyledTableCell>
                  <StyledTableCell>Solicitante</StyledTableCell>
                  <StyledTableCell>Nº Recibo</StyledTableCell>
                  <StyledTableCell>Tipo Constancia</StyledTableCell>
                  <StyledTableCell>Monto</StyledTableCell>
                  <StyledTableCell>Estado</StyledTableCell>
                  <StyledTableCell>Fecha Registro</StyledTableCell>
                  <StyledTableCell>Detalle Solicitud</StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    Acciones
                  </StyledTableCell>
                </StyledTableRow>
              </TableHead>

              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleFilterClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
                sx={{
                  p: 2,
                  "& .MuiTextField-root": {
                    m: 1,
                    width: "250px",
                  },
                }}
              >
                {filterType === "searchDNI" && (
                  <Box sx={{ p: 2 }}>
                    <TextField
                      placeholder="Buscar por DNI"
                      aria-label="Buscar por DNI"
                      value={searchDNI}
                      onChange={handleSearchDNIChange}
                      autoFocus
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                    <Box
                      sx={{
                        mt: 1,
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Button
                        size="small"
                        onClick={() => setSearchDNI("")}
                        disabled={!searchDNI}
                      >
                        Limpiar
                      </Button>
                    </Box>
                  </Box>
                )}
              </Popover>

              <TableBody>
                {loading ? (
                  <StyledTableRow>
                    <StyledTableCell colSpan={11} align="center">
                      <CircularProgress size={24} />
                    </StyledTableCell>
                  </StyledTableRow>
                ) : filteredRows && filteredRows.length > 0 ? (
                  filteredRows
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, idx) => (
                      <StyledTableRow key={row.id_solicitud_constancia}>
                        <StyledTableCell>
                          {page * rowsPerPage + idx + 1}
                        </StyledTableCell>
                        <StyledTableCell>{row.DNI_usuario}</StyledTableCell>
                        <StyledTableCell>
                          {row.NombreCompleto_usuario}
                        </StyledTableCell>
                        <StyledTableCell>{row.numero_recibo}</StyledTableCell>
                        <StyledTableCell>
                          {tiposConstancia[row.fk_id_constancia] ||
                            "DESCONOCIDO"}
                        </StyledTableCell>
                        <StyledTableCell>L.{row.monto}</StyledTableCell>
                        <StyledTableCell>
                          {getEstadoConstanciaText(row)}
                        </StyledTableCell>
                        <StyledTableCell>
                          {row.fecha_registro
                            ? row.fecha_registro.split("T")[0] +
                              " " +
                              row.fecha_registro.split("T")[1].substring(0, 8)
                            : "-"}
                        </StyledTableCell>
                        <StyledTableCell>
                          {row.detalle_solicitud}
                        </StyledTableCell>
                        <StyledTableCell>
                          <Box display="flex" justifyContent="center">
                            <Tooltip
                              title="Ver Solicitud"
                              arrow
                              placement="left-start"
                            >
                              <IconButton
                                onClick={() =>
                                  handleClick(row.id_solicitud_constancia)
                                }
                              >
                                <VisibilityIcon
                                  sx={{ color: "green", fontSize: 30 }}
                                />
                              </IconButton>
                            </Tooltip>
                            {row.fk_id_estado === 6 && (
                              <Tooltip
                                title="Aceptar Solicitud"
                                arrow
                                placement="left-start"
                              >
                                <IconButton
                                  onClick={() => handleOpenDialog(row)}
                                  disabled={patchLoading}
                                >
                                  <CheckCircleIcon sx={{ color: "green" }} />
                                </IconButton>
                              </Tooltip>
                            )}

                            {(row.fk_id_estado === 6 ||
                              isPagadaPendienteEmitir(row)) && (
                              <Tooltip
                                title="Enviar a Subsanar Solicitud"
                                arrow
                                placement="left-start"
                              >
                                <IconButton
                                  onClick={() => handleOpenDialogSubsanar(row)}
                                  disabled={patchLoading}
                                >
                                  <HandymanIcon sx={{ color: "green" }} />
                                </IconButton>
                              </Tooltip>
                            )}

                            {row.fk_id_estado === 2 ? (
                              isPendienteEntregar(row) ? (
                                <Tooltip
                                  title="Entregar Constancia"
                                  arrow
                                  placement="left-start"
                                >
                                  <span>
                                    <IconButton
                                      onClick={() =>
                                        handleOpenDialogEntrega(row)
                                      }
                                      disabled={patchLoading}
                                    >
                                      <ExitToAppIcon
                                        sx={{
                                          color: "green",
                                          fontSize: 30,
                                        }}
                                      />
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              ) : isPagadaPendienteEmitir(row) ? (
                                <Tooltip
                                  title="Confirmar Constancia Emitida"
                                  arrow
                                  placement="left-start"
                                >
                                  <span>
                                    <IconButton
                                      onClick={() =>
                                        handleOpenDialogRecibido(row)
                                      }
                                      disabled={patchLoading}
                                    >
                                      <AssignmentTurnedInIcon
                                        sx={{
                                          color: "green",
                                          fontSize: 30,
                                        }}
                                      />
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              ) : null
                            ) : row.fk_id_estado === 6 ? (
                              <Tooltip
                                title="Rechazar Solicitud"
                                arrow
                                placement="left-start"
                              >
                                <IconButton
                                  onClick={() => handleOpenDialogRechazar(row)}
                                  disabled={patchLoading}
                                >
                                  <DeleteIcon sx={{ color: "Red" }} />
                                </IconButton>
                              </Tooltip>
                            ) : null}
                          </Box>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))
                ) : (
                  <StyledTableRow>
                    <StyledTableCell colSpan={11} align="center">
                      No hay datos.
                    </StyledTableCell>
                  </StyledTableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredRows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            labelRowsPerPage={"Filas por página"}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>

        <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
          <DialogTitle textAlign={"center"}>Confirmar Aceptación</DialogTitle>
          <DialogContent>
            <DialogContentText>
              ¿Está seguro de aceptar la Constancia{" "}
              <b>
                {selectedRow && tiposConstancia[selectedRow.fk_id_constancia]}{" "}
              </b>
              con N° de recibo <b>{selectedRow && selectedRow.numero_recibo}</b>{" "}
              {selectedRow &&
                (selectedRow.monto === "0.00"
                  ? "para proceder con la siguiente etapa?"
                  : "para proceder con el pago?")}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setOpenDialog(false)}
              color="error"
              disabled={patchLoading}
            >
              No
            </Button>
            <Button
              onClick={handleAccept}
              color="primary"
              variant="contained"
              disabled={patchLoading}
            >
              {patchLoading ? <CircularProgress size={18} /> : "Sí"}
            </Button>
          </DialogActions>
        </Dialog>

        {/* DIALOG DE ÉXITO */}
        <Dialog open={openSuccessDialog} onClose={handleSuccessDialogClose}>
          <DialogTitle>
            <Box display="flex" alignItems="center" justifyContent="center">
              <span style={{ fontWeight: 500 }}>Solicitud Aprobada</span>
              <CheckCircleIcon style={{ color: "green", marginLeft: 10 }} />
            </Box>
          </DialogTitle>
          <DialogContent>
            <DialogContentText textAlign={"justify"}>
              La constancia ha sido <strong>Aprobada exitosamente</strong> y ha
              avanzado a la siguiente etapa.
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center" }}>
            <Button
              onClick={handleSuccessDialogClose}
              color="primary"
              variant="contained"
              sx={{ mx: "auto", minWidth: 120 }}
            >
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>

        {/* DIALOG PARA SUBSANAR */}
        <Dialog
          open={openDialogSubsanar}
          onClose={() => setOpenDialogSubsanar(false)}
        >
          <DialogTitle textAlign={"center"}>Enviar a Subsanar</DialogTitle>
          <DialogContent>
            <DialogContentText>
              ¿Confirmar que desea enviar a <b>subsanación</b> la constancia{" "}
              <b>
                {selectedRow && tiposConstancia[selectedRow.fk_id_constancia]}{" "}
              </b>
              con N° de recibo <b>{selectedRow && selectedRow.numero_recibo}</b>{" "}
              del solicitante{" "}
              <b>{selectedRow && selectedRow.NombreCompleto_usuario}</b>?
            </DialogContentText>
            <TextField
              multiline
              rows={4}
              autoFocus
              margin="dense"
              label="Observación"
              type="text"
              fullWidth
              variant="outlined"
              value={observacion} // Estado para almacenar la observación
              onChange={(e) => setObservacion(e.target.value)}
              error={errorObservacion}
              helperText={
                errorObservacion ? "La observación es obligatoria" : ""
              }
              required // Hacer obligatorio
            />
            <FormControl
              component="fieldset"
              sx={{ mt: 2 }}
              error={errorDocumentos}
            >
              <FormLabel component="legend">Documentos a Subsanar:</FormLabel>
              <Box
                sx={{
                  border: errorDocumentos
                    ? "1px solid #d32f2f"
                    : "1px solid rgba(0, 0, 0, 0.23)",
                  borderRadius: 1,
                  p: 2,
                  backgroundColor: errorDocumentos ? "#fff5f5" : "transparent",
                }}
              >
                <FormGroup required>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={camposSeleccionados.copiaDNI}
                        onChange={(e) => {
                          setCamposSeleccionados({
                            ...camposSeleccionados,
                            copiaDNI: e.target.checked,
                          });
                        }}
                      />
                    }
                    label="Copia de DNI"
                  />
                  {(
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={camposSeleccionados.copiaAcuCancelacion}
                          onChange={(e) => {
                            setCamposSeleccionados({
                              ...camposSeleccionados,
                              copiaAcuCancelacion: e.target.checked,
                            });
                          }}
                        />
                      }
                      label="Copia de Acuerdo de Cancelación"
                    />
                  )}

                  {selectedRow?.jubilacionEnProceso ? (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={camposSeleccionados.copiaSolPension}
                          onChange={(e) => {
                            setCamposSeleccionados({
                              ...camposSeleccionados,
                              copiaSolPension: e.target.checked,
                            });
                          }}
                        />
                      }
                      label="Copia de Solicitud de Pensión"
                    />
                  ) : null}
                </FormGroup>
              </Box>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleCloseDialogSubsanar}
              color="error"
              disabled={patchLoading}
            >
              No
            </Button>
            <Button
              onClick={handleAcceptSubsanar}
              color="primary"
              variant="contained"
              disabled={errorObservacion || errorDocumentos}
            >
              {patchLoading ? <CircularProgress size={18} /> : "Sí"}
            </Button>
          </DialogActions>
        </Dialog>

        {/* DIALOG DE ÉXITO */}
        <Dialog
          open={openSuccessDialogSubsanar}
          onClose={handleSuccessDialogSubsanarClose}
        >
          <DialogTitle>
            <Box display="flex" alignItems="center" justifyContent="center">
              <span style={{ fontWeight: 500 }}>Solicitud Enviada</span>
              <CheckCircleIcon style={{ color: "green", marginLeft: 10 }} />
            </Box>
          </DialogTitle>
          <DialogContent>
            <DialogContentText textAlign={"justify"}>
              La solicitud de constancia se envío a Subsanar con éxito y fue
              enviada al participante.
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center" }}>
            <Button
              onClick={handleSuccessDialogSubsanarClose}
              color="primary"
              variant="contained"
              sx={{ mx: "auto", minWidth: 120 }}
            >
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>

        {/* DIALOG PARA RECHAZAR */}
        <Dialog
          open={openDialogRechazar}
          onClose={() => setOpenDialogRechazar(false)}
        >
          <DialogTitle textAlign={"center"}>Rechazar Solicitud</DialogTitle>
          <DialogContent>
            <DialogContentText>
              ¿Está seguro que desea <b>rechazar</b> la Constancia{" "}
              <b>
                {selectedRow && tiposConstancia[selectedRow.fk_id_constancia]}{" "}
              </b>
              con N° de recibo <b>{selectedRow && selectedRow.numero_recibo}</b>{" "}
              del solicitante{" "}
              <b>{selectedRow && selectedRow.NombreCompleto_usuario}</b>?
            </DialogContentText>
            <TextField
              multiline
              rows={4}
              autoFocus
              margin="dense"
              label="Observación"
              type="text"
              fullWidth
              variant="outlined"
              value={observacion} // Estado para almacenar la observación
              onChange={(e) => setObservacion(e.target.value)}
              error={!observacion}
              helperText={!observacion ? "La observación es obligatoria" : ""}
              required // Hacer obligatorio
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleCloseDialogRechazar}
              color="error"
              disabled={patchLoading}
            >
              No
            </Button>
            <Button
              onClick={handleAcceptRechazar}
              color="primary"
              variant="contained"
              disabled={!observacion}
            >
              {patchLoading ? <CircularProgress size={18} /> : "Sí"}
            </Button>
          </DialogActions>
        </Dialog>

        {/* DIALOG DE ÉXITO */}
        <Dialog
          open={openSuccessDialogRechazar}
          onClose={handleSuccessDialogRechazarClose}
        >
          <DialogTitle>
            <Box display="flex" alignItems="center" justifyContent="center">
              <span style={{ fontWeight: 500 }}>Solicitud Cancelada</span>
              <CheckCircleIcon style={{ color: "green", marginLeft: 10 }} />
            </Box>
          </DialogTitle>
          <DialogContent>
            <DialogContentText textAlign={"justify"}>
              La solicitud de constancia se cancelo con éxito.
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center" }}>
            <Button
              onClick={handleSuccessDialogRechazarClose}
              color="primary"
              variant="contained"
              sx={{ mx: "auto", minWidth: 120 }}
            >
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>

        {/* DIALOG PARA CONFIRMAR CONSTANCIA EMITIDA */}
        <Dialog
          open={openDialogRecibido}
          onClose={handleCloseDialogRecibido}
        >
          <DialogTitle textAlign={"center"}>
            Confirmar Constancia Emitida
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              &iquest;Est&aacute; seguro que desea{" "}
              <b>confirmar la constancia emitida</b>?
            </DialogContentText>
            <input
              accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
              style={{ display: "none" }}
              id="constancia-digital-cc"
              type="file"
              onChange={(e) =>
                setArchivoConstanciaDigital(e.target.files[0])
              }
            />
            <label htmlFor="constancia-digital-cc">
              <Button
                variant="outlined"
                component="span"
                fullWidth
                sx={{ mt: 2 }}
              >
                Adjuntar Constancia Escaneada
              </Button>
            </label>

            {archivoConstanciaDigital && (
              <Typography
                variant="body2"
                sx={{ mt: 1, color: "text.secondary" }}
              >
                Archivo seleccionado: {archivoConstanciaDigital.name}
              </Typography>
            )}
            {errorRecepcion && (
              <DialogContentText color="error" sx={{ mt: 2 }}>
                {errorRecepcion}
              </DialogContentText>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleCloseDialogRecibido}
              color="error"
              disabled={patchLoading}
            >
              NO
            </Button>
            <Button
              onClick={handleAcceptRecibido}
              color="primary"
              variant="contained"
              disabled={!archivoConstanciaDigital || patchLoading}
            >
              {patchLoading ? <CircularProgress size={18} /> : <>S&Iacute;</>}
            </Button>
          </DialogActions>
        </Dialog>

        {/* DIALOG DE EXITO RECEPCION */}
        <Dialog
          open={openSuccessDialogRecibido}
          onClose={handleSuccessDialogRecibidoClose}
        >
          <DialogTitle>
            <Box display="flex" alignItems="center" justifyContent="center">
              <span style={{ fontWeight: 500 }}>Solicitud Recibida</span>
              <CheckCircleIcon style={{ color: "green", marginLeft: 10 }} />
            </Box>
          </DialogTitle>
          <DialogContent>
            <DialogContentText textAlign={"justify"}>
              La solicitud de constancia fue marcada como recibida con
              &eacute;xito y pas&oacute; al estado{" "}
              <strong>Pendiente de Entregar</strong>.
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center" }}>
            <Button
              onClick={handleSuccessDialogRecibidoClose}
              color="primary"
              variant="contained"
              sx={{ mx: "auto", minWidth: 120 }}
            >
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>

        {/* DIALOG PARA ENTREGAR */}
        <Dialog open={openDialogEntrega} onClose={handleCloseDialogEntrega}>
          <DialogTitle textAlign={"center"}>Entregar Constancia</DialogTitle>
          <DialogContent>
            <DialogContentText>
              &iquest;Est&aacute; seguro que desea{" "}
              <b>confirmar la entrega</b> de la constancia?
            </DialogContentText>
            <input
              accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
              style={{ display: "none" }}
              id="comprobante-entrega-cc"
              type="file"
              onChange={(e) => setArchivoComprobante(e.target.files[0])}
            />
            <label htmlFor="comprobante-entrega-cc">
              <Button
                variant="outlined"
                component="span"
                fullWidth
                sx={{ mt: 2 }}
              >
                Adjuntar Comprobante de Entrega
              </Button>
            </label>

            {archivoComprobante && (
              <Typography
                variant="body2"
                sx={{ mt: 1, color: "text.secondary" }}
              >
                Archivo seleccionado: {archivoComprobante.name}
              </Typography>
            )}
            {errorEntrega && (
              <DialogContentText color="error" sx={{ mt: 2 }}>
                {errorEntrega}
              </DialogContentText>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleCloseDialogEntrega}
              color="error"
              disabled={patchLoading}
            >
              NO
            </Button>
            <Button
              onClick={handleAcceptEntrega}
              color="primary"
              variant="contained"
              disabled={!archivoComprobante || patchLoading}
            >
              {patchLoading ? <CircularProgress size={18} /> : <>S&Iacute;</>}
            </Button>
          </DialogActions>
        </Dialog>

        {/* DIALOG DE EXITO ENTREGA */}
        <Dialog
          open={openSuccessDialogEntrega}
          onClose={handleSuccessDialogEntregaClose}
        >
          <DialogTitle>
            <Box display="flex" alignItems="center" justifyContent="center">
              <span style={{ fontWeight: 500 }}>Solicitud Entregada</span>
              <CheckCircleIcon style={{ color: "green", marginLeft: 10 }} />
            </Box>
          </DialogTitle>
          <DialogContent>
            <DialogContentText textAlign={"justify"}>
              La solicitud de constancia fue marcada como entregada con
              &eacute;xito.
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center" }}>
            <Button
              onClick={handleSuccessDialogEntregaClose}
              color="primary"
              variant="contained"
              sx={{ mx: "auto", minWidth: 120 }}
            >
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>
      </>
    </div>
  );
}

export default ListaSolConstanciasRevisionCC;
